export default {
  FETCH_DASHBOARD: 'FETCH_DASHBOARD',
  FETCH_DASHBOARD_SUCCESS: 'FETCH_DASHBOARD_SUCCESS',
  FETCH_DASHBOARD_PRODUCCION: 'FETCH_DASHBOARD_PRODUCCION',
  FETCH_DASHBOARD_PRODUCCION_SUCCESS: 'FETCH_DASHBOARD_PRODUCCION_SUCCESS'
}